import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './componenttextimage.css'

const Componenttextimage = (props) => {
  return (
    <div className={`componenttextimage-container ${props.rootClassName} `}>
      <div className="componenttextimage-thq-column-elm">
        <h1 className="componenttextimage-text1 H1_large">
          {props.componentTitle}
        </h1>
        <p className="componenttextimage-text2">
          {props.textComponent ?? (
            <Fragment>
              <span className="componenttextimage-text3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur
              </span>
            </Fragment>
          )}
        </p>
      </div>
      <img
        alt={props.image1Alt}
        src={props.image1Src}
        className="componenttextimage-thq-image1-elm"
      />
    </div>
  )
}

Componenttextimage.defaultProps = {
  image1Alt: '',
  textComponent: undefined,
  componentTitle: 'componentTitle',
  image1Src: '',
  rootClassName: '',
}

Componenttextimage.propTypes = {
  image1Alt: PropTypes.string,
  textComponent: PropTypes.element,
  componentTitle: PropTypes.string,
  image1Src: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default Componenttextimage
